import React from "react";


const SAEmpty = (props) => {
    return (
        <>
            <div className={`sa-empty ${props?.center ? 'center' : ''}`}>
                <span>{props?.icon ? props?.icon : <i className="fa-solid fa-box-open"></i>}</span>
                <p className="mt-1">{props?.message}</p>
            </div>
        </>
    )
};

export default SAEmpty;